import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { searchProducts } from '../services/api';
import { trackSearch, trackViewItemList } from '../utils/gtm';
import './SearchPage.css';

function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchResults = async () => {
      if (!query) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const data = await searchProducts(query);
        setResults(data.products);
        setTotal(data.total);
        setLoading(false);

        // Track search event in GA4
        trackSearch(query, data.total);

        // Track search results as item list
        if (data.products?.length > 0) {
          trackViewItemList(
            data.products.map(p => ({
              id: p.sku || p.id,
              name: p.name,
              category: p.categories?.[0]?.name || 'Search Results',
              price: parseFloat(p.sale_price || p.regular_price || 0)
            })),
            `Search: ${query}`
          );
        }
      } catch (error) {
        console.error('Error searching products:', error);
        setLoading(false);
      }
    };

    fetchResults();
  }, [query]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="search-page">
      <div className="search-header">
        <h1>Search Results for "{query}"</h1>
        <p>{total} products found</p>
      </div>

      {results.length > 0 ? (
        <div className="products-grid">
          {results.map((product) => (
            <Link
              key={product.id}
              to={`/products/${product.slug || product.id}`}
              className="product-card"
            >
              <div className="product-image">
                {product.images && product.images.length > 0 ? (
                  <img src={product.images[0].src} alt={product.name} />
                ) : (
                  <div className="no-image">No Image</div>
                )}
              </div>
              <h3>{product.name}</h3>
              <div className="product-price">
                {parseFloat(product.sale_price) > 0 ? (
                  <>
                    <span className="sale-price">${product.sale_price}</span>
                    <span className="regular-price">${product.regular_price}</span>
                  </>
                ) : parseFloat(product.regular_price) > 0 ? (
                  <span className="price">${product.regular_price}</span>
                ) : (
                  <span className="price">Request Quote</span>
                )}
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="no-results">
          <p>No products found matching your search.</p>
        </div>
      )}
    </div>
  );
}

export default SearchPage;
